import { useAuth } from '@/contexts/AuthContext';

export const localDate = (date = new Date()) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
export const monthLabel = month => new Date(`${month}-01T12:00:00`).toLocaleDateString('nl-BE', { month: 'long', year: 'numeric' });
export const dateLabel = date => new Date(`${date}T12:00:00`).toLocaleDateString('nl-BE', { day: '2-digit', month: '2-digit', year: 'numeric' });
export const cashError = error => typeof error.response?.data?.detail === 'string' ? error.response.data.detail : 'Controleer de invoer en probeer opnieuw.';
export const cashNumber = value => String(value ?? '').trim() === '' ? NaN : Number(String(value).replace(',', '.'));
export const cashLinesPayload = lines => lines.map(line => ({ ...line, aantal: cashNumber(line.aantal), prijs: cashNumber(line.prijs),
  korting: cashNumber(line.korting ?? 0), btw: cashNumber(line.btw), scan_korting_euro: cashNumber(line.scan_korting_euro ?? 0) }));
export const useCashAccess = () => {
  const { user } = useAuth();
  return { allowed: user?.role !== 'verkoper' || !!user?.machtigingen?.leverbonnen_toegang,
    writable: user?.role !== 'alleen-lezen', profit: user?.role === 'admin' || !!user?.mag_winst_zien,
    identity: `${user?.id || user?._id || user?.email}:${user?.verkoper_id || ''}` };
};

export const cashTotals = lines => {
  let excl = 0, vat = 0;
  for (const line of lines) {
    const gross = cashNumber(line.aantal) * cashNumber(line.prijs);
    const net = line.scan_korting_mode === 'euro' ? gross - Math.sign(gross) * cashNumber(line.scan_korting_euro ?? 0) : gross * (1 - cashNumber(line.korting ?? 0) / 100);
    excl += net; vat += net * cashNumber(line.btw ?? 0) / 100;
  }
  const rounded = value => Math.round((value + Number.EPSILON) * 100) / 100;
  return { excl: rounded(excl), btw_totaal: rounded(vat), totaal: rounded(rounded(excl) + rounded(vat)) };
};